import React from 'react';
import { Helmet } from 'react-helmet';
import { useGTMInit } from '../hooks/useGTMInit';
import { jsx as _jsx } from "react/jsx-runtime";
export function DataLayerScript() {
  const [GTMScript, setGTMscript] = React.useState(null);
  useGTMInit({
    onStart: script => {
      setGTMscript(script);
    }
  });
  return /*#__PURE__*/_jsx(Helmet, {
    children: GTMScript ? /*#__PURE__*/_jsx("script", {
      children: GTMScript
    }) : null
  });
}